<template>
  <div
    v-if="show"
    class="ifream-modal"
  >
    <div class="ifream-main">
      <i
        class="iconfont iconicon-test5"
        @click.stop="hide"
      />
      <iframe
        :webkitallowfullscreen="true"
        :mozallowfullscreen="true"
        :allowfullscreen="true"
        width="740"
        height="586"
        :src="perpaerIfreamLink(routerName, user, from)"
      />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { perpaerIfreamLink } from '@/lib/help'
import { mapState } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['baseinfo']),
    from () {
      const { from } = this.$route.query
      return from
    },
    user () {
      return this.baseinfo.truename
    },
    routerName () {
      return this.$route.name
    }
  },
  methods: {
    perpaerIfreamLink,
    hide () {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style scoped lang="scss">
.ifream-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgba(0,0,0,.5);
  z-index: 2002;
  .ifream-main {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 740px;
    height: 586px;
    background: #fff;
    border-radius: 4px;
    iframe {
      border-radius: 4px;
    }
    .iconfont {
      position: absolute;
      top: 20px;
      right: 24px;
      font-size: 16px;
    }
    .iconfont:hover {
      cursor: pointer;
    }
  }
}
</style>
